/* src/app/self-enrollment/self-enroll/self-enroll.component.css */
.heading {
  font-family:
    Open Sans,
    Arial,
    sans-serif;
  font-weight: 800;
  font-size: 11pt;
  margin-bottom: 10px;
}
.subheading {
  font-family:
    Open Sans,
    Arial,
    sans-serif;
  font-weight: 650;
  font-size: 10pt;
}
.setupBody {
  font-family:
    Open Sans,
    Arial,
    sans-serif;
  font-weight: 500;
  font-size: 10pt;
  margin-bottom: 10px;
}
.enrollment {
  background-color: white;
  border-color: #DCDCDC;
  padding: 30px;
  margin: 50px 100px 20px 100px;
}
a:not([href]):not([tabindex]) {
  color: #3b74b0;
  text-decoration: underline;
}
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
.modal-header {
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
}
.modal-footer {
  background-color: white;
}
@media (max-width: 767px) {
  .enrollment {
    margin: 50px 20px 20px 20px;
  }
  img {
    width: 75%;
  }
}
/*# sourceMappingURL=self-enroll.component.css.map */
